import { getJson, getObject, postJson, postObject } from "../ChoiceApi";
import { IEHIExportLinkItem, IEHIAddTaskListItem, IEHIExportQueueItem, IEHIPassedResponse, IEHICancelTaskListItem, EHIExportTabName, IEHIExportQueueResult, IEHIAuditItem } from "../Models/Export/EHIExportModel";


export async function getTaskList(active: EHIExportTabName): Promise<IEHIExportQueueResult | undefined> {
    return (await getObject(`api/export/b10/GetTaskList/${active}`));
}
export async function getExportLinks(queuePatientRecordId: number): Promise<IEHIExportLinkItem[] | undefined> {
    return (await getObject(`api/export/b10/GetTaskListLinks/${queuePatientRecordId}`));
}
export async function downloadExportLink(linkId: number, linkName: string) {
    return (await getObject(`api/export/b10/DownloadTaskLink/${linkId}/${linkName}`));
} 
export async function addTaskListItem(payload: IEHIAddTaskListItem): Promise<IEHIExportQueueItem | undefined> {
    return (await postObject("api/export/b10/AddTaskListItem", payload));   
} 
export async function cancelTaskListItem(payload: IEHICancelTaskListItem): Promise<IEHIPassedResponse | undefined> {
    return (await postObject("api/export/b10/CancelTaskListItem", payload));   
} 
export async function getAuditList(): Promise<IEHIAuditItem[] | undefined> {
    return (await getObject("api/export/b10/GetAuditList"));
}

